import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { serviceurl } from 'src/app/constant/constant';
import { SKIP_ERROR_TOAST } from 'src/app/interceptors/error.interceptor';
import { Review } from './marketplace.models';
import { unwrapPage, Paginated } from './pagination.util';

@Injectable({ providedIn: 'root' })
export class ReviewService {
  private apiUrl = serviceurl + 'api/v1/reviews';

  constructor(private http: HttpClient) {}

  listForListing(listingId: number | string): Observable<Review[]> {
    return this.http.get<Paginated<Review> | Review[]>(`${this.apiUrl}/`, {
      params: new HttpParams().set('listing', listingId),
    }).pipe(unwrapPage<Review>());
  }

  listForVendor(vendorSlug: string): Observable<Review[]> {
    return this.http.get<Paginated<Review> | Review[]>(`${this.apiUrl}/`, {
      params: new HttpParams().set('vendor', vendorSlug),
    }).pipe(unwrapPage<Review>());
  }

  create(payload: {
    listing?: number;
    order_line?: number;
    subscription_plan?: number;
    subscription?: number;
    rating: number;
    body?: string;
  }): Observable<Review> {
    // The item page shows its own message (already reviewed, not owned).
    return this.http.post<Review>(`${this.apiUrl}/`, payload, {
      context: new HttpContext().set(SKIP_ERROR_TOAST, true),
    });
  }

  respond(reviewId: number, vendorResponse: string): Observable<Review> {
    return this.http.post<Review>(`${this.apiUrl}/${reviewId}/respond/`, {
      vendor_response: vendorResponse,
    });
  }
}
